import React, { createContext, useMemo, useState } from 'react';

import { SiteConfigManager } from '@atlas/core';

export const LiveChatContext = createContext();

export const useLiveChatContextState = () => {
  const [isOpened, setIsOpened] = useState(false);

  const chatType = useMemo(
    () => SiteConfigManager.getConfig('config.config.support.live_chat.mobile.type'),
    [],
  );

  const toggleIsOpened = React.useCallback(() => {
    if (chatType && window.LiveChatWidget) {
      window.LiveChatWidget.call('maximize');
    } else if (chatType && window.Tawk_API) {
      window.Tawk_API.maximize();
    } else if (chatType && window.$respond) {
      window.$respond.do('chat:open');
    } else if (chatType && window.zE) {
      if (chatType === 'ZendeskWebWidget') {
        window.zE('webWidget', 'open');
        window.zE('webWidget', 'show');
      } else {
        window.zE('messenger', 'open');
        window.zE('messenger', 'show');
      }
    } else if (chatType && window.octadesk) {
      window.octadesk.chat.showApp();
    } else if (chatType === 'Infobip' && window.liveChat) {
      window.liveChat('show');
    } else {
      setIsOpened(val => !val);
    }
  }, [setIsOpened, chatType]);

  const openChat = React.useCallback(() => {
    try {
      if (!chatType) {
        setIsOpened(true);
        return;
      }

      if (window.LiveChatWidget) {
        window.LiveChatWidget.call('maximize');
      } else if (window.Tawk_API) {
        window.Tawk_API.maximize();
      } else if (window.$respond) {
        window.$respond.do('chat:open');
      } else if (window.zE) {
        const ns = chatType === 'ZendeskWebWidget' ? 'webWidget' : 'messenger';
        window.zE(ns, 'open');
        window.zE(ns, 'show');
      } else if (window.octadesk) {
        window.octadesk.chat.showApp();
      } else if (chatType === 'Infobip' && window.liveChat) {
        window.liveChat('show');
      } else {
        setIsOpened(true);
      }
    } catch {
      // Swallow provider errors: deep-link open must never surface a chat error.
    }
  }, [setIsOpened, chatType]);

  return {
    isOpened,
    openChat,
    setIsOpened,
    toggleIsOpened,
  };
};
